import React, { useState } from 'react';
import {
  TextInput,
  SelectInput,
  required,
  SimpleForm,
  SaveButton,
  Toolbar,
} from 'react-admin';
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  withStyles,
} from '@material-ui/core';
import { customDataProvider } from '../data-provider';
import Modal from 'react-modal';
import CloseIcon from '@material-ui/icons/Close';

const validateReason = [required()];
const validateOther = [required()];
const validateAmount = [required()];

const CustomCheckbox = withStyles({
  root: {
    color: '#2196F3',
    '&$checked': {
      color: '#2196F3',
    },
  },
  checked: {},
})(props => <Checkbox color="default" {...props} />);

export const Refund = ({
  showRefund,
  setShowRefund,
  appointment,
  refetch,
  transaction,
  refundReasons,
}) => {
  const [reason, setReason] = useState('');
  const [fullRefund, setFullRefund] = useState(true);
  const [addonSelected, setAddonSelected] = useState(false);

  const addonService = appointment?.addon_services;
  const handleSave = form => {
    const { amount, reason, otherReason } = form;
    let payload = {
      full_refund: fullRefund,
      reason: reason === 'Other' ? otherReason : reason,
    };
    if (!fullRefund) {
      payload.amount = amount;
    }
    if (appointment) {
      customDataProvider
        .update('appointmentRefund', {
          id: appointment?.id,
          payload: { ...payload, addon_only: addonSelected },
        })
        .then(() => {
          setShowRefund(false);
          refetch();
        });
    } else {
      if (transaction) {
        customDataProvider
          .update('transactionsRefund', {
            id: transaction?.id,
            payload,
          })
          .then(() => {
            setShowRefund(false);
            refetch();
          });
      }
    }
  };

  const handleFullRefundChange = event => {
    const checked = event.target.checked;
    setFullRefund(checked);
    if (checked) {
      setAddonSelected(false);
    }
  };

  const handleAddonChange = event => {
    const checked = event.target.checked;
    setAddonSelected(checked);
    if (checked) {
      setFullRefund(false);
    }
  };

  const RefundToolbar = props => (
    <Toolbar {...props}>
      <SaveButton label="Refund" onSave={handleSave} />
    </Toolbar>
  );

  return (
    <Modal isOpen={showRefund}>
      <div className="modal-header">
        <div className="light-text">Refund</div>
        <CloseIcon
          onClick={() => setShowRefund(false)}
          className="close-button"
        />
      </div>
      <SimpleForm
        toolbar={<RefundToolbar />}
        // initialValues={{}}
      >
        <div style={{ width: '100%' }}>
          Are you sure you want to issue a refund to this guest?
        </div>
        <FormGroup>
          <FormControlLabel
            control={
              <CustomCheckbox
                checked={fullRefund}
                onChange={handleFullRefundChange}
                name="fullRefund"
              />
            }
            label="Process Full Refund"
          />
          {addonService?.length ? (
            <FormControlLabel
              control={
                <CustomCheckbox
                  checked={addonSelected}
                  onChange={handleAddonChange}
                  name="addon"
                />
              }
              label="Addon Only"
            />
          ) : (
            <></>
          )}
        </FormGroup>
        {!fullRefund && (
          <TextInput
            label="Refund Amount"
            source="amount"
            validate={validateAmount}
          />
        )}
        <SelectInput
          source="reason"
          validate={validateReason}
          onChange={e => setReason(e.target.value)}
          choices={refundReasons}
        />
        {reason === 'Other' && (
          <TextInput
            label="Other Reason"
            source="otherReason"
            validate={validateOther}
          />
        )}
      </SimpleForm>
    </Modal>
  );
};
